// The capability token travels only in the URL fragment (spec 7.2, I1, I3):
// never in server logs, never in a Referer. The page reads it once, then
// removes it from the address bar.
const TOKEN_RE = /^[A-Za-z0-9._~-]{8,2048}$/;

export function readFragment(hash) {
  const params = new URLSearchParams(String(hash ?? '').replace(/^#/, ''));
  const out = {};
  for (const k of ['t', 'p']) {
    const v = params.get(k);
    if (v && TOKEN_RE.test(v)) out[k] = v;
  }
  const a = params.get('a');
  if ((a === 'yes' || a === 'no') && out.t) out.a = a;
  return out;
}

export function takeFragment(win = window) {
  const out = readFragment(win.location.hash);
  if (win.location.hash) win.history.replaceState(null, '', `${win.location.pathname}${win.location.search ?? ''}`);
  return out;
}

export function ensureNoReferrer(doc = document) {
  if (doc.head.querySelector('meta[name="referrer"]')) {
    doc.head.querySelector('meta[name="referrer"]').setAttribute('content', 'no-referrer');
    return;
  }
  const m = doc.createElement('meta');
  m.setAttribute('name', 'referrer');
  m.setAttribute('content', 'no-referrer');
  doc.head.appendChild(m);
}
